import React from 'react';
import Badge from '../Badge';
import { formatCurrency } from '../../../Utils/Formatters';
import { useCartContext } from '../../../Contexts/CartContext';

interface CartValueDetailsProps {
  cart: any;
}

const CartValueDetails = ({
  cart,
}: CartValueDetailsProps) => {

  const { loadingUpdateQuantity, loadingCurrentCart } = useCartContext();

  return (
    <div className='grid gap-0.5 text-sm'>

        <div className='flex justify-between '>
          <span>Subtotal</span>
          <span className='flex items-center'>
              {(loadingUpdateQuantity || loadingCurrentCart)
                ? <div className="bg-gray-300 h-3 rounded-full w-16 animate-pulse"></div>
                : formatCurrency(cart.total)
              }
            </span>
        </div>

        {(cart.total_discount > 0 || cart.coupon_code) &&
          <div className='flex justify-between'>
            <span className='flex items-center gap-1'>
              Descontos
              {cart.coupon_code && <Badge type='success' outline className='py-1 leading-3 font-bold md:text-xs'>{cart.coupon_code}</Badge>}
            </span>
            <span className='flex items-center'>
              {(loadingUpdateQuantity || loadingCurrentCart)
                ? <div className="bg-gray-300 h-3 rounded-full w-16 animate-pulse"></div>
                : <>- { formatCurrency(cart.total_discount) }</>
              }
            </span>
          </div>
        }

        {cart.extra_tax > 0 &&
          <div className='flex justify-between'>
            <span>Taxa de serviço</span>
            <span className='flex items-center'>
              {(loadingUpdateQuantity || loadingCurrentCart)
                ? <div className="bg-gray-300 h-3 rounded-full w-16 animate-pulse"></div>
                : formatCurrency(cart.extra_tax)
              }
            </span>
          </div>
        }

        {cart.extra_value > 0 &&
          <div className='flex justify-between'>
            <span>Taxa extra</span>
            <span className='flex items-center'>
              {(loadingUpdateQuantity || loadingCurrentCart)
                ? <div className="bg-gray-300 h-3 rounded-full w-16 animate-pulse"></div>
                : formatCurrency(cart.extra_value)
              }
            </span>
          </div>
        }

        <div className='flex justify-between text-base font-extrabold text-gray-600'>
          <span>Total</span>
          <span className='flex items-center'>
            {(loadingUpdateQuantity || loadingCurrentCart)
              ? <div className="bg-gray-300 h-4 rounded-full w-20 animate-pulse"></div>
              : formatCurrency(Number(cart.total_with_discount) + Number(cart.extra_tax))
            }
          </span>
        </div>


    </div>
  )
}

export default CartValueDetails;